import React from "react";
import TemplateLibraryIcon from "../../assets/icons/template_rec.svg2";
import LibraryLinks from "./LibraryLinks";
import PageHeader from "../Common/PageHeader";
import WidgetContainer from "../Common/WidgetContainer";

const defaultWidgetLayout = [
  { i: "./ComponentsWidget.jsx", x: 0, y: 0, w: 5, h: 10 },
  { i: "./DocumentLibraryWidget.jsx", x: 5, y: 0, w: 5, h: 10 },
  { i: "./LogicLibraryWidget.jsx", x: 10, y: 0, w: 5, h: 10 },
  { i: "./ImportedContactsWidget.jsx", x: 15, y: 0, w: 5, h: 10 },
  { i: "./ApiProfilesWidget.jsx", x: 0, y: 10, w: 5, h: 10 },
  { i: "./ApiDataCollectionsWidget.jsx", x: 5, y: 10, w: 5, h: 10 },
];

export default function LibraryLandingPage() {
  return (
    <div>
      <PageHeader
        Icon={TemplateLibraryIcon}
        heading="Library"
        subheading="Location for your stored and published information"
      />
      <LibraryLinks />

      <WidgetContainer
        defaultLayout={defaultWidgetLayout}
        lsField="libraryWidgetLayout"
      />
    </div>
  );
}
